import { AssinaturaType } from "../../types/assinatura";
import { AssinaturaActionType } from "../types/assinatura";
import { ReducerActionType } from "../types/common";

interface AssinaturaReducerInterface {
  assinatura?: AssinaturaType;
}

const InitialState: AssinaturaReducerInterface = {
  assinatura: undefined,
};

export function AssinaturaReducer(
  state = InitialState,
  action: ReducerActionType<AssinaturaActionType>
): AssinaturaReducerInterface {
  switch (action.type) {
    case "LOAD_ASSINATURA":
      return { ...state, assinatura: action.payload };
    default:
      return state;
  }
}
